<h2 class="text-center" mat-dialog-title mat-dialog-draggable-title
  style="margin-bottom: 10px !important;  font-weight: bold !important;">
  {{'kyc.identification_method_title' | translate}}
</h2>
<p class="text-center" style="color: red; font-size: 14px; white-space: pre-line;">{{'kyc.note_kyc_enterpise' | translate}}</p>
<div style="display:flex">
  <div style="
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 1rem 1rem !important;
  ">
    <div class="justify-content-center " style=" 
      display: flex;
      padding: 15px !important; 
      text-align: center;
      border: 1px solid rgb(189, 189, 189); 
      border-radius: 3px; 
      flex-grow: 1;
      flex-direction: column;
      justify-content: space-between;">
      <p class="text-center" style="font-weight: bold;">{{'kyc.sign' | translate}}</p>
      <img style="width:73%; display: block; margin: 0 auto;" src="./assets/images/sign.png" alt="sign">
      <p class="text-center" style='text-align: justify !important;'>
        {{'kyc.sign_text1' | translate}}<br />{{'kyc.sign_text2' | translate}}</p>
      <button mat-raised-button color="primary" class="mat-raised-button mat-primary mb-1" style="margin-top: auto !important;"
        (click)="onClickBtnViewUpdate()">
        <mat-icon class="mr-0">gesture</mat-icon>
        {{'kyc.sign' | translate}}
      </button>
    </div>
    <div class="justify-content-center" style=" 
      display: flex; 
      padding: 15px !important; 
      text-align: center;
      border: 1px solid rgb(189, 189, 189); 
      border-radius: 3px; 
      flex-grow: 1;
      flex-direction: column;
      justify-content: space-between;">
      <p class="text-center bold" style="font-weight: bold;">EKYC</p>
      <img style="width:64%; display: block; margin: 0 auto;" src="./assets/images/ekyc.png" alt="ekyc">
      <p class="text-center" style='text-align: justify !important;'>
        {{'kyc.ekyc_text1' | translate}}<br />{{'kyc.ekyc_text2' | translate}}</p>
      <button mat-raised-button color="primary" class="mat-raised-button mat-primary mb-1" style="margin-top: auto !important;" (click)="onKyc()">
        <img alt="time" src="./assets/images/qr-icon.svg" width="15">
        {{'kyc.make_ekyc_btn' | translate}}
      </button>
    </div>
  </div>
</div>

<div mat-dialog-actions class="justify-content-center">
  <button mat-stroked-button color="primary" type="button" (click)="onNoClick()"
    class="mr-3 mat-stroked-button mat-primary">
    <mat-icon class="mr-0">cancel</mat-icon>{{'button.exit' | translate}}
  </button>
</div>